<div class="header_2">
  <nav class="navbar navbar-expand-lg fixed-top navbar-light bg-light navbar-offcanvas"
    style="background: #fff !important">
    <div class="d-none d-lg-block">
      <button class="navbar-toggler d-block" type="button" id="navToggle" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
    </div>
    <div class="d-block d-lg-none">
      <div class="d-flex flex-row mb-2">
        <button class="navbar-toggler d-block" type="button" id="navToggle" (click)="toggle()">
          <span class="navbar-toggler-icon"></span>
        </button>
        <img class="logo_neocredito" src="assets/img/logo.svg" alt="Logo neocredito" routerLink="/intermediario/home" />
      </div>
    </div>

    <div class="w-100">
      <div class="d-none d-lg-block">
        <div class="row">
          <div class="col-6 d-flex align-items-center justify-content-start">
            <img class="logo_neocredito" src="assets/img/logo.svg" alt="Logo neocredito"
              routerLink="/intermediario/home" />
            </div>
            <div class="col-6 d-flex justify-content-end">
              <div class="profile">
                <div class="data-info me-3 text-end">
                  <p style="margin: 0"><strong>Ip: </strong>{{ ip }}</p>
                  <p style="margin: 0">
                    <strong>Último acceso:</strong>
                    {{ ultimaConexion | date: "dd/MM/yyyy, hh:mm" }}
                  </p>
                  <p style="margin: 0"><span class="fas fa-calendar-day"></span> {{dia}}, {{fecha}}</p>
                  <p style="margin: 0"><span class="fas fa-clock"></span> {{hora}}:{{minutos}}:{{segundos}} {{ampm}}</p>
                </div>
                <img src="assets/img/Ico_1.png" alt="Perfil" width="55px" />
                <div class="control">
                  <h5>{{ user.nombre }}</h5>
                  <a (click)="cerrarSesion()" style="cursor: pointer">Cerrar Sesión</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-block d-lg-none">
        <div class="row">
          <div class="col-6">
            <p style="margin: 0; font-size: 0.8rem">
              <strong>Ip: </strong>{{ ip }}
            </p>
            <p style="margin: 0; font-size: 0.8rem">
              <strong>Último acceso:</strong>
              {{ ultimaConexion | date: "dd/MM/yyyy, hh:mm" }}
            </p>
            <p style="margin: 0; font-size: 0.8rem"><span class="fas fa-calendar-day"></span> {{dia}}, {{fecha}}</p>
            <p style="margin: 0; font-size: 0.8rem"><span class="fas fa-clock"></span> {{hora}}:{{minutos}}:{{segundos}} {{ampm}}</p>
          </div>
          <div class="col-6 d-flex justify-content-end">
            <div class="control">
              <img src="assets/img/Ico_1.png" alt="Perfil" />
              <h5 style="font-size: 1rem; font-weight: bold">
                {{ user.nombre }}
              </h5>
              <a (click)="cerrarSesion()" style="cursor: pointer">Cerrar Sesión</a>
            </div>
          </div>
        </div>
      </div>

      <div class="navbar-collapse offcanvas-collapse" (mouseleave)="hideMenuBar()">
        <div class="d-flex flex-column mt-3">
          <div class="d-flex flex align-items-center">
            <button class="navbar-toggler d-block" type="button" id="navToggle" (click)="toggle()">
              <span class="navbar-toggler-icon"></span>
            </button>

            <img src="assets/img/Home/svg/Logo_neocredito_footer.svg" alt="" style="width: 10rem; margin: 0 auto" />
          </div>

          <ul class="navbar-nav me-auto mt-5 menuIntermediario">
            @for (menu of menusBancoldex; track menu) {
              <li class="nav-item dropdown container-fluid">
                <a class="nav-link dropdown-toggle" id="dropdown03" data-bs-toggle="dropdown" aria-haspopup="true"
                  aria-expanded="false">
                  <div style="display: inline-flex; width: 10rem">
                    {{ menu.nombre }}
                  </div>
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdown03">
                  @for (children of menu.funcionalidades; track children) {
                    <a [routerLink]="children.url"
                      class="dropdown-item hvr-forward" (click)="hideMenuBar()">
                      {{ children.nombre }}
                    </a>
                  }
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    </nav>
  </div>
